var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blink-cont pointer",style:(_vm.getStyles)},_vm._l((50),function(idx){return _c('elem',{key:'blink-' + idx,attrs:{"mode":_vm.getMyLuoItem(idx),"currentPhoto":_vm.currentPhoto,"canIShow":_vm.canIShow}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }